import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Service } from '@angular/core';
import { Observable } from 'rxjs';
import { ChargingStationLocationRelationDefault } from 'src/app/features/department/charging-station-location-relation-model';
import { EnvironmentLoaderService } from './environment-loader.service';
import { ChargingStationLocationDefaultsRequest } from 'src/app/features/charging-station-location/charging-station-location-model';

@Service()
export class ChargingStationLocationRelationService {
  private http = inject(HttpClient);
  private environmentLoaderService = inject(EnvironmentLoaderService);

  apiUrl: string;
  protected httpHeaders: HttpHeaders;

  constructor() {
    this.apiUrl = this.environmentLoaderService.config['serviceBaseUrl'] + '/api/v1/admin/ChargingStationLocationRelation';

    this.httpHeaders = new HttpHeaders({
      'Access-Control-Allow-Origin': this.apiUrl,
      'Content-Type': 'application/json',
    });
  }

  getDefaults(chargingStationLocationRelationId: number): Observable<ChargingStationLocationRelationDefault> {
    const url = `${this.apiUrl}/${chargingStationLocationRelationId}/defaults`;
    return this.http.get<ChargingStationLocationRelationDefault>(url);
  }

  upsertChargingStationLocationDefaults(
    chargingStationLocationRelationId: number,
    data: ChargingStationLocationDefaultsRequest
  ): Observable<void> {
    const url = `${this.apiUrl}/${chargingStationLocationRelationId}/defaults`;
    return this.http.put<void>(url, data, {
      headers: this.httpHeaders,
    });
  }

  setOperatingDate(locationIdentifier: string) {
    return this.http.put(`${this.apiUrl}/${locationIdentifier}/setOperatingDate`, null);
  }
}
